"use strict";
export const AVATAR_COLORS = [
  "#BFE7FD",
  "#BFF2EF",
  "#D7D1FC",
  "#BFF2CC",
  "#DFE8EC",
  "#EDCCF7",
  "#F3E3CF",
  "#F8CEED",
  "#FEDDC9",
  "#FDECBF"
];
const generateHash = (input) => {
  return input.split("").reduce(
    (prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0,
    0
  );
};
const generateColorIndexByUserName = (userName) => {
  const hashNumber = generateHash(userName + userName.length);
  const colorRange = AVATAR_COLORS.length;
  return (hashNumber % colorRange + colorRange) % colorRange;
};
export const getAvatarColorByName = (userName) => {
  if (!userName) {
    return;
  }
  const index = generateColorIndexByUserName(userName);
  return AVATAR_COLORS[index];
};
